import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthCard } from './auth-card';
import { HelpStrip } from './help-strip';

// Full-viewport shell: Skip (top-right) + centered auth card + help strip.
export function AuthShell({
  children,
  onSkip,
  skipTo = '/',
}: {
  children: ReactNode;
  onSkip?: () => void;
  skipTo?: string;
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onSkip) {
      onSkip();
    } else {
      navigate(skipTo);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <div className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {/* footer={<TermsFooter />} */}
          <AuthCard onBack={handleBack}>
            {children}
          </AuthCard>
          <HelpStrip />
        </div>
      </div>
    </div>
  );
}
